import * as React from "react";

export const useImageUploaderState = (
  onFileUpload: (file: File) => Promise<void>
) => {
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState<string | undefined>(
    undefined
  );

  const clearErrorMessage = () => {
    setErrorMessage(undefined);
  };

  const handleImageUpload = async (file: File) => {
    setLoading(true);
    clearErrorMessage();
    await onFileUpload(file);
    setLoading(false);
  };

  return {
    loading,
    errorMessage,
    setErrorMessage,
    clearErrorMessage,
    handleImageUpload,
  };
};
